import primary from './primary'
import primaryLight from './primary-light'
import primaryGradient from './primary-gradient'
import primaryOutline from './primary-outline'
import secondary from './secondary'
import secondaryLight from './secondary-light'
import secondaryGradient from './secondary-gradient'
import secondaryOutline from './secondary-outline'
import gradient from './gradient'
import dark from './dark'
import white from './white'
import black from './black'
import disabled from './disabled'
import icon from './icon'

export default {
  primary,
  'primary-light': primaryLight,
  'primary-gradient': primaryGradient,
  'primary-outline': primaryOutline,
  secondary,
  'secondary-light': secondaryLight,
  'secondary-gradient': secondaryGradient,
  'secondary-outline': secondaryOutline,
  gradient,
  dark,
  white,
  black,
  disabled,
  icon
}
